import script from "./main01Swiper.vue?vue&type=script&setup=true&name=main01Swiper&lang=js"
export * from "./main01Swiper.vue?vue&type=script&setup=true&name=main01Swiper&lang=js"

const __exports__ = script;

export default __exports__